/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbContactSummary } from './HchbContactSummary';
import {
    HchbContactSummaryFromJSON,
    HchbContactSummaryFromJSONTyped,
    HchbContactSummaryToJSON,
} from './HchbContactSummary';

/**
 * 
 * @export
 * @interface HchbPhysicianSummary
 */
export interface HchbPhysicianSummary {
    /**
     * 
     * @type {number}
     * @memberof HchbPhysicianSummary
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof HchbPhysicianSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPhysicianSummary
     */
    npi?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPhysicianSummary
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPhysicianSummary
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPhysicianSummary
     */
    phone?: string;
    /**
     * 
     * @type {Array<HchbContactSummary>}
     * @memberof HchbPhysicianSummary
     */
    contacts?: Array<HchbContactSummary>;
}

/**
 * Check if a given object implements the HchbPhysicianSummary interface.
 */
export function instanceOfHchbPhysicianSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function HchbPhysicianSummaryFromJSON(json: any): HchbPhysicianSummary {
    return HchbPhysicianSummaryFromJSONTyped(json, false);
}

export function HchbPhysicianSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPhysicianSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'npi': !exists(json, 'npi') ? undefined : json['npi'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'contacts': !exists(json, 'contacts') ? undefined : ((json['contacts'] as Array<any>).map(HchbContactSummaryFromJSON)),
    };
}

export function HchbPhysicianSummaryToJSON(value?: HchbPhysicianSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'npi': value.npi,
        'city': value.city,
        'state': value.state,
        'phone': value.phone,
        'contacts': value.contacts === undefined ? undefined : ((value.contacts as Array<any>).map(HchbContactSummaryToJSON)),
    };
}

